import axios from 'axios';

const API_BASE_URL = 'https://backend.digitalanthropologylab.org/wp-json/acf/v3';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// Persistent cache using localStorage (versioned so backend switches don't serve stale data)
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
const CACHE_PREFIX = 'dal-api-v2:';

const getCachedData = (key) => {
  const cached = localStorage.getItem(CACHE_PREFIX + key);
  if (!cached) return null;
  try {
    const { data, timestamp } = JSON.parse(cached);
    if (Date.now() - timestamp < CACHE_DURATION) {
      return data;
    }
    return null;
  } catch {
    return null;
  }
};

const setCachedData = (key, data) => {
  localStorage.setItem(CACHE_PREFIX + key, JSON.stringify({
    data,
    timestamp: Date.now(),
  }));
};

// API endpoints
export const fetchPeople = async () => {
  const cacheKey = 'people';
  const cached = getCachedData(cacheKey);
  if (cached) return cached;

  try {
    const { data } = await api.get('/people?per_page=100');
    setCachedData(cacheKey, data);
    return data;
  } catch (error) {
    console.error('Error fetching people:', error);
    throw error;
  }
};

export const fetchProjects = async () => {
  const cacheKey = 'projects';
  const cached = getCachedData(cacheKey);
  if (cached) return cached;

  try {
    const { data } = await api.get('/projects?per_page=100');
    setCachedData(cacheKey, data);
    return data;
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
};

export const fetchPublications = async () => {
  const cacheKey = 'publications';
  const cached = getCachedData(cacheKey);
  if (cached) return cached;

  try {
    const { data } = await api.get('/publications?per_page=100');
    setCachedData(cacheKey, data);
    return data;
  } catch (error) {
    console.error('Error fetching publications:', error);
    throw error;
  }
};

export const fetchNews = async () => {
  const cacheKey = 'news';
  const cached = getCachedData(cacheKey);
  if (cached) return cached;

  try {
    const { data } = await api.get('/news?per_page=100');
    setCachedData(cacheKey, data);
    return data;
  } catch (error) {
    console.error('Error fetching news:', error);
    throw error;
  }
};

export const fetchWorkAreas = async () => {
  const cacheKey = 'workareas';
  const cached = getCachedData(cacheKey);
  if (cached) return cached;

  try {
    const { data } = await api.get('/workareas?per_page=100');
    setCachedData(cacheKey, data);
    return data;
  } catch (error) {
    console.error('Error fetching work areas:', error);
    throw error;
  }
};

export const fetchUtilities = async () => {
  const cacheKey = 'utilities';
  const cached = getCachedData(cacheKey);
  if (cached) return cached;

  try {
    const { data } = await api.get('/utility?per_page=100');
    setCachedData(cacheKey, data);
    return data;
  } catch (error) {
    console.error('Error fetching utilities:', error);
    throw error;
  }
};

// Prefetch data for a specific route
export const prefetchData = async (route) => {
  switch (route) {
    case '/people':
      return fetchPeople();
    case '/projects':
      return fetchProjects();
    case '/publications':
      return fetchPublications();
    case '/news':
      return fetchNews();
    case '/workareas':
      return fetchWorkAreas();
    default:
      return null;
  }
}; 